import React, { useEffect, useState, useRef } from 'react'
import { useSearchParams, Outlet, NavLink, useNavigate } from 'react-router-dom'
import './index.css'
import { LogoutOutlined } from '@ant-design/icons';
import Menu from '../Menu';
import { store } from '../../redux/store';
export default function Main() {
  const { menuList, name } = store.getState().uData.userInfo;
  let navigate = useNavigate();
  const contentRef = useRef(null);
  const [mheight, setMheight] = useState(window.innerHeight); // 存储当前激活的div的索引

  useEffect(() => {
    navigate('customer');//第一次加载
    const handleResize = () => {
      setMheight(contentRef.current.offsetHeight < window.innerHeight ? window.innerHeight : contentRef.current.offsetHeight + 90);
    };
    window.addEventListener('resize', handleResize);

    const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        setMheight(entry.contentRect.height < window.innerHeight ? window.innerHeight : entry.contentRect.height + 90);
      }
    });
    if (contentRef.current) {
      resizeObserver.observe(contentRef.current);
    }
    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', handleResize);
    };
  }, []); // 空数组确保只在挂载时设置观察者


  return (
    <div className='main-home'>


      <div className='menu-content' style={{ height: mheight }}>
        <div className='logo'>
          对账管理平台LOGO
        </div>
        <div>
          <Menu items={menuList} />
        </div>

      </div>
      <div className='header-right' >
        <div className='user-info'>
          <div className='user-info-style'>
            {name}
          </div>
          <div>
            <NavLink to="/login"><LogoutOutlined /></NavLink>
          </div>
        </div>
        <div className='menu-item' ref={contentRef}>
          <Outlet />
        </div>

      </div>
    </div>
  )
}
